import { render, staticRenderFns } from "./LayoutRecipe.vue?vue&type=template&id=e61dbb94&scoped=true"
import script from "./LayoutRecipe.vue?vue&type=script&lang=js"
export * from "./LayoutRecipe.vue?vue&type=script&lang=js"
import style0 from "./LayoutRecipe.vue?vue&type=style&index=0&id=e61dbb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61dbb94",
  null
  
)

export default component.exports